import { injectIntl } from "react-intl";

import { HostHubUpcomingPanel } from "./HostHubUpcomingPanel";

export default injectIntl(HostHubUpcomingPanel);
